module.exports = __webpack_public_path__ + "static/media/ethNews.5a613f42.png";